import _extends from "@babel/runtime/helpers/extends";
import styled from "@emotion/styled";
import { color as colorFn } from "@smartsheet/design-tokens-react";
import Lottie from "lottie-react";
import React, { useEffect, useState } from "react";
import { SPINNER_CONTAINER_SIZES_MAP } from "./constants";
import ursaSpinner from "./lottie_files/ursa_spinner.json";
export const Spinner = _ref => {
  let {
    clientId,
    color,
    initialDelay,
    size = "medium",
    ...rest
  } = _ref;
  const [visible, setVisible] = useState(initialDelay === undefined);
  useEffect(() => {
    if (initialDelay) {
      const timer = setTimeout(() => {
        setVisible(true);
      }, initialDelay);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [initialDelay]);
  return /*#__PURE__*/React.createElement(Container, _extends({
    size: size,
    color: color
  }, rest, {
    "data-client-id": clientId
  }), visible && /*#__PURE__*/React.createElement(Lottie, {
    animationData: ursaSpinner
  }));
};
const Container = styled("div")`
    box-sizing: border-box;
    display: block;
    color: ${_ref2 => {
  let {
    color
  } = _ref2;
  return color ? color : colorFn("color--background--primary--strong");
}};
    path {
        stroke: currentColor;
    }
    font-size: 0;
    height: ${_ref3 => {
  let {
    size
  } = _ref3;
  return SPINNER_CONTAINER_SIZES_MAP[size];
}}px;
    width: ${_ref4 => {
  let {
    size
  } = _ref4;
  return SPINNER_CONTAINER_SIZES_MAP[size];
}}px;
    position: relative;
    pointer-events: none;
`;
//# sourceMappingURL=Spinner.js.map